import { type CSSProperties, useMemo, useState } from "react";

import { cn } from "@/lib/cn";
import type { StaticEntityType } from "@config";
import { Wrapper } from "../Button.styles";
import "../styles/_main.scss";
import type { DefaultProps, EditorDataProps, EditorSlotsProps } from "../types";
import { preventRender } from "../utils";
import { Element } from "./Element";

export const AcceptButtonLibrary = ({
  entity,
  editorSlots,
  editorData,
}: {
  entity: StaticEntityType;
  editorSlots?: EditorSlotsProps;
  editorData?: EditorDataProps;
}) => {
  const [submitted, setSubmitted] = useState(false);
  const { settings, id } = entity as StaticEntityType<DefaultProps>;
  const isEmpty = useMemo(() => preventRender({ id }), [id]);
  const width = editorData?.width || settings.width;
  if (isEmpty) return null;

  return (
    <>
      <Wrapper
        $align={settings.horizontalAlignment}
        style={
          {
            "--resize-width": `${submitted ? "100" : width}%`,
          } as CSSProperties
        }
        className={cn(
          "accept-button-71d72f0d-8486-4d9d-b58c-a5b9facf4701",
          editorData?.className,
        )}
      >
        {editorSlots?.overlaySlot}
        {editorSlots?.resizeSlot}
        <div
          ref={editorData?.elementRef}
          className={cn(
            "accept-button__wrapper-inner tw-w-[var(--resize-width)]",
            {
              "max-md:tw-w-[80%]": Number(width) < 80,
              "max-max:tw-w-[var(--resize-width)]": Number(width) >= 80,
            },
          )}
        >
          <Element
            settings={settings}
            editableContent={editorSlots?.editableContentSlot}
            setSubmittedState={() => setSubmitted(true)}
          />
        </div>
      </Wrapper>
      {editorSlots?.activateSlot}
      {editorSlots?.warningSlot}
    </>
  );
};
